<div>
  <div>
    <h5 class="text-center title-color">
      Fluxo & Conversão
    </h5>
  </div>
  <div class="p-mt-1 chart-container">
    <apx-chart 
      [series]="chartOptions.series" 
      [chart]="chartOptions.chart" 
      [dataLabels]="chartOptions.dataLabels" 
      [plotOptions]="chartOptions.plotOptions" 
      [xaxis]="chartOptions.xaxis"
      [fill]="chartOptions.fill"
      [tooltip]="chartOptions.tooltip"
      [legend]="chartOptions.legend"
    >
    </apx-chart>

  </div>
</div>